// components/Team.js
import React, { useState } from 'react';

const Team = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const teamMembers = [
    {
      id: 1,
      name: 'Dennis Ngwimbi',
      position: 'Managing Director and Founder',
      description: 'Dennis is the Managing Director and Founder of the company, holding a Bachelor of Science in Renewable Energy Engineering. He provides strategic leadership and technical direction, driving the company\'s vision to deliver innovative, reliable, and sustainable solar and renewable energy solutions.',
      categories: ['Leadership'],
      image: '/images/team/Dennis Ngwimbi.jpeg' 
    },
    {
      id: 2,
      name: 'Shyreen Chalunda',
      position: 'Operations Director',
      description: 'Shyreen is the Operations Director with a Bachelor of Library and Information Science. She oversees operations, documentation, and internal processes, ensuring efficient coordination, compliance, and smooth execution of renewable energy projects.',
      categories: ['Leadership', 'Operations'],
      image: '/images/team/business.jpg'
    },
    {
      id: 3,
      name: 'Steven Nyirongo',
      position: 'Operational Manager',
      description: 'Steven is a Project Engineer with a Bachelor of Science in Renewable Energy Technology. He specializes in solar system design, project planning, and implementation, ensuring efficient and sustainable energy solutions that meet industry standards.',
      categories: ['Technical'],
      image: '/images/team/Steven Nyirongo.jpeg'
    },
    {
      id: 4,
      name: 'Kondwani Nyirongo',
      position: 'Irrigation Engineer',
      description: 'Kondwani holds a Bachelor of Science in Irrigation Engineering and supports the execution of integrated energy solutions. He contributes to solar-powered and environmentally sustainable infrastructure projects through effective engineering coordination.',
      categories: ['Technical'],
      image: '/images/team/Kondwani Nyirongo.jpeg'
    },
    {
      id: 5,
      name: 'Gilbert Kapeni',
      position: 'Chief Technician',
      description: 'Gilbert is the Chief Technician with a Diploma in Solar Photovoltaic Installation. He leads solar system installations, commissioning, and maintenance, ensuring reliability, safety, and optimal system performance.',
      categories: ['Technical'],
      image: '/images/team/Gilbert Kapeni.jpeg'
    },
    {
      id: 6,
      name: 'Pemphero Chasowa',
      position: 'Solar System Technician',
      description: 'Pemphero is a Solar System Technician with an Advanced Certificate in Solar Photovoltaic Installation. He supports solar installations, system testing, and maintenance, contributing to efficient and long-lasting clean energy solutions.',
      categories: ['Technical'],
      image: '/images/team/Pemphero Chasowa.jpeg '
    },
    {
      id: 7,
      name: 'Violet Mbewu',
      position: 'Sales and Business Development Manager',
      description: 'Violet holds a Bachelor of Commerce in Business Administration and manages sales coordination and administrative functions. She supports customer engagement and business growth within the renewable energy sector.',
      categories: ['Sales', 'Administration'],
      image: '/images/team/Violet Mbeu.jpeg'
    },
    {
      id: 8,
      name: 'Felister Phiri',
      position: 'Finance and Administration Officer',
      description: 'Felister is an Finance and Administration Officer with a Diploma in Accounting. She supports financial administration, reporting, and compliance, ensuring sound financial management across renewable energy operations.',
      categories: ['Accounting'],
      image: '/images/team/Felister Phiri.jpeg'
    }
  ];

  const filters = ['All', 'Leadership', 'Operations', 'Technical', 'Sales', 'Administration', 'Accounting'];

  const filteredMembers = activeFilter === 'All' 
    ? teamMembers 
    : teamMembers.filter(member => member.categories.includes(activeFilter));

  return (
    <section id="team" className="team">
      <div className="container">
        <div className="section-title">
          <h2>Our Team</h2>
          <p>Sunsight Energy has a team of well-trained Engineers and technicians who believe in teamwork and professionalism.</p>
        </div>

        {/* Filter Buttons */}
        <div className="team-filters">
          {filters.map(filter => (
            <button
              key={filter}
              className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter)}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* Team Members Grid */}
        <div className="team-grid">
          {filteredMembers.map(member => (
            <div key={member.id} className="team-member-card">
              {/* Replace abbreviation with image */}
              <div className="member-image">
                <img 
                  src={member.image} 
                  alt={member.name}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/images/team/placeholder.jpg'; // fallback image
                  }}
                />
              </div>
              <h3 className="member-name">{member.name}</h3>
              <p className="member-position">{member.position}</p>
              <p className="member-description">{member.description}</p>
              <div className="member-tags">
                {member.categories.map(category => (
                  <span 
                    key={`${member.id}-${category}`} 
                    className="tag"
                    onClick={() => setActiveFilter(category)}
                  >
                    {category}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;